// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 1537); hand-edits allowed (see docs/architecture.md)

/** `this.IMPL_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_IMPL_DEF(): any {
  return {
    "std_attack": {
      "id": 1,
      "attack": 70,
      "protect": 0,
      "health": 0,
      "level": 1,
      "gold": 390000,
      "diam": 390,
      "limit": 1,
      "name": "Чип Атаки",
      "special": {}
    },
    "std_protect": {
      "id": 2,
      "attack": 0,
      "protect": 70,
      "health": 0,
      "level": 1,
      "gold": 320000,
      "diam": 320,
      "limit": 1,
      "name": "Чип Защиты",
      "special": {}
    },
    "std_health": {
      "id": 3,
      "attack": 0,
      "protect": 0,
      "health": 500,
      "level": 1,
      "gold": 430000,
      "diam": 430,
      "limit": 1,
      "name": "Чип Здоровья",
      "special": {}
    },
    "phoenix": {
      "id": 4,
      "attack": 100,
      "protect": 100,
      "health": 600,
      "level": 1,
      "gold": 680000,
      "diam": 680,
      "limit": 1,
      "name": "Универсальный чип Феникс",
      "special": {}
    },
    "phoenix2": {
      "id": 5,
      "attack": 125,
      "protect": 125,
      "health": 1000,
      "level": 1,
      "gold": 750000,
      "diam": 750,
      "limit": 1,
      "name": "Феникс Mk 2",
      "special": {}
    },
    "dragon": {
      "id": 6,
      "attack": 150,
      "protect": 150,
      "health": 1200,
      "level": 1,
      "gold": 890000,
      "diam": 890,
      "limit": 1,
      "name": "Универсальный чип Дракон",
      "special": { "fire_res": true }
    },
    "dragon2": {
      "id": 7,
      "attack": 180,
      "protect": 180,
      "health": 1350,
      "level": 1,
      "gold": 1120000,
      "diam": 1120,
      "limit": 1,
      "name": "Дракон Mk 2",
      "special": { "fire_res": true, "poison_res": true, "para_res": true }
    }
  };
}
